import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { Helmet } from 'react-helmet-async';
import { CustomersContent } from './components/CustomersContent';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const Customers: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Kunden | Starjack Admin</title>
            </Helmet>

            <CustomersContent />
        </>
    );
};

Customers.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
Customers.isProtected = true;

Customers.permissions = [
    Permission.CUSTOMER_NAV,
    Permission.CUSTOMER_DETAIL_NAV,
];

export default Customers;
